<template>
  <div>
    <header-common :nav-list="navList">
      <template v-for="(nl, i) in navList" :key="i" #[nl.slot]>
        <el-row
          v-if="nl.type === 'list'"
          class="list-box"
          :gutter="10"
          justify="center"
        >
          <el-col v-for="(item, j) in nl.children" :key="j" :sm="6"
            ><div @click="goPage(nl.path, item.path,null,nl.slot,j)" style="cursor: pointer">
              {{ item.name }}
            </div>
          </el-col>
          <!-- <el-divider class="divider" /> -->
        </el-row>
        <el-row
          v-else-if="nl.type === 'list-item'"
          class="list-item-box"
          :gutter="10"
          justify="center"
        >
          <el-col v-for="(item, j) in nl.children" :key="j" :sm="6"
            ><div class="content">
              <ul>
                <li class="content-title" @click="$router.push(nl.path+item.path)">
                  {{ item.name }}
                </li>
                <li
                  v-for="(mo, k) in item.children"
                  :key="k"
                  class="content-item"
                >
                  <span class="content-item-name" @click="goPage(nl.path, item.path,mo.param,nl.slot,k)">{{
                    mo.name
                  }}</span>
                </li>
              </ul>
            </div>
          </el-col>
          <!-- <el-divider class="divider" /> -->
        </el-row>
      </template>
    </header-common>
  </div>
</template>

<script>
import Elinkht from "@/views/solution/Elinkht.vue";
import HeaderCommon from "./app-common/HeaderCommon.vue";
export default {
  //import引入组件才能使用
  components: { HeaderCommon, Elinkht },
  props: {},
  data() {
    return {
      navList: [
        {
          path: "/home",
          name: "首页",
          children: [],
        },
        {
          path: "/about",
          name: "关于我们",
          slot: "about",
          type: "list",
          children: [
            {
              path: "#m1",
              name: "公司简介",
            },
            {
              path: "#m2",
              name: "企业文化",
            },
            {
              path: "#m3",
              name: "核心优势",
            },
            {
              path: "#m4",
              name: "荣誉资质",
            },
          ],
        },
        {
          path: "/solution",
          name: "产品服务",
          slot: "solution",
          type: "list-item",
          children: [
            {
              path: "/elinkht",
              name: "大宗一站通平台",
              children: [
                {
                  param: "transactions",
                  name: "线上交易",
                },
                {
                  param: "intelligence-logistics",
                  name: "智慧物流",
                },
                {
                  param: "digital-warehousing",
                  name: "数字化仓储",
                },
                {
                  param: "supply-chain-finance",
                  name: "供应链金融",
                },
              ],
            },
            {
              path: "/digitization",
              name: "数智化解决方案",
              children: [
                {
                  param: "consolidation-station",
                  name: "集运站解决方案",
                },
                {
                  param: "coal-washery",
                  name: "洗煤厂解决方案",
                },
                {
                  param: "logistics-park",
                  name: "物流园解决方案",
                },
                {
                  param: "smart-mines",
                  name: "智慧矿山解决方案",
                },
              ],
            },
            {
              path: "/it-services",
              name: "信息技术服务",
              children: [
                {
                  param: "data-center",
                  name: "数据中台",
                },
                {
                  param: "iot-entral-platform",
                  name: "物联中台",
                },
                {
                  param: "scm-system",
                  name: "SCM系统",
                },
                {
                  param: "erp-management-system",
                  name: "ERP管理系统",
                },
                {
                  param: "data-consulting-services",
                  name: "数据咨询服务",
                },
              ],
            },
          ],
        },
        {
          path: "/company",
          name: "企闻资讯",
          slot: "company",
          type: "list",
          children: [
            {
              path: "/dynamic",
              name: "企业动态",
            },
            {
              path: "/news",
              name: "行业新闻",
            },
          ],
        },
      ],
    };
  },
  // 方法集合
  methods: {
    goPage(rootPath,path,param,slot,index) {
        if(param){
            this.$router.push({path:`${rootPath+path}/${param}`,target: "_self",});
        }else{
            if(slot==='about'){
                path = `${rootPath}`
                this.$router.push({path:`${path}`,hash:`#m${index+1}`});
                return;
            }else{
                path = `${rootPath+path}`
            }
            this.$router.push({path:`${path}`});
        }
    },
  },
};
</script>
<style scoped lang="less">
.list-box {
  background-color: rgba(5, 6, 11, 0.9);
  text-align: center;
  .el-col {
    div {
      &:hover {

        background-color: rgba(99, 124, 222, 0.9);
      }
    }
  }
  .divider {
    margin-top: 0px;
    border-top: 1px solid rgb(36, 38, 50);
  }
}
.list-item-box {
  background-color: rgba(5, 6, 11, 0.9);
  text-align: center;
  background: url("@/assets/img/home/menu-content-item.png") no-repeat no-repeat;
  background-size: 100% 100%;
  .el-col {
    .content {
      ul {
        text-align: center;
        .content-title {
          position: relative;
          font-size: 2rem;
          cursor: pointer;
          &:hover{
            color: #409eff;
          }
          &::before {
            content: "";
            position: absolute;
            left: 130px;
            top: 8.09rem;
            height: 0.05rem;
            width: 19.18rem;
            background: linear-gradient(to left, transparent, #fff);
          }
        }
        .content-item {
          font-size: 1.6rem;
          line-height: 2rem;
          margin: 1rem auto;
          color: rgb(212, 212, 205);
          .content-item-name {
            cursor: pointer;
            &:hover{
                color: #409eff;
            }
          }
        }
      }
    }
  }
  .divider {
    margin-top: 0px;
    border-top: 1px solid rgb(36, 38, 50);
  }
}
</style>